import React from 'react'
import { t } from 'src/translations'
import { StyleMetaProps } from 'public/components/default_template/meta/StyleMeta'
import { SiteRestaurantLocation, SiteTheme } from 'shared/js/types'
import { RequestContextProps } from 'src/lib/js/context'
import { TrackingEvents } from 'src/shared/components/common/tracking/TrackingEvents'
import WithFallback500 from './WithFallback500'

const SitesFallback500 = ({
  staticContext,
  meta,
  siteTheme,
  rxName,
  rxLocations,
  errorMessage
}: Partial<
  {
    meta?: StyleMetaProps
    siteTheme?: SiteTheme
    rxName?: string
    rxLocations?: SiteRestaurantLocation[] | null
    errorMessage?: string
  } & RequestContextProps
>) => {
  return (
    <WithFallback500
      title={t('sites-fallback-500.title')}
      subtitle={t('sites-fallback-500.subtitle')}
      errorMessage={errorMessage}
      trackingMessage={TrackingEvents.SITES_FALLBACK_500_VIEW}
      staticContext={staticContext}
      meta={meta}
      siteTheme={siteTheme}
      rxName={rxName}
      rxLocations={rxLocations}
    />
  )
}

export default SitesFallback500
